module.exports = __webpack_public_path__ + "static/media/engineering.ab39a55d.jpg";